import React from 'react'
import {
  Box,
  Typography,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { gtmEvent } from 'lib/gtm'
import { useStyles as useEditFormStyles } from 'pages/pga-coach/bookings/events/edit/edit-event-form/styles'

const useStyles = makeStyles(theme => ({
  optionsColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    width: '100%',
    paddingTop: theme.spacing(1),
  },
  optionLabel: {
    alignItems: 'flex-start',
    margin: 0,
    '& .MuiFormControlLabel-label': {
      marginTop: 2,
      marginLeft: theme.spacing(0.5),
      paddingTop: theme.spacing(0.25),
    },
  },
  optionTitle: {
    fontSize: '1rem',
    fontWeight: 400,
    color: theme.palette.text.primary,
    lineHeight: 1.25,
  },
  optionDescription: {
    fontSize: '0.8125rem',
    color: theme.palette.text.secondary,
    lineHeight: 1.5,
    marginTop: theme.spacing(1),
  },
  radio: {
    padding: theme.spacing(1),
    marginTop: -2,
    color: '#70787C',
    '&.Mui-checked': {
      color: '#0053FF',
    },
  },
}))

const VISIBILITY_OPTIONS = [
  {
    value: 'ACTIVE',
    title: 'Public',
    description:
      'The booking type will be visible and bookable by you and your students.',
  },
  {
    value: 'INACTIVE',
    title: 'Private',
    description: 'The booking type will only be visible and bookable by you.',
  },
]

const BookingTypeVisibility = ({ status, setStatus, isEditFlow = false }) => {
  const classes = useStyles()
  const editClasses = useEditFormStyles()

  const handleStatus = (event, newStatus) => {
    setStatus(newStatus)
  }

  const setVisibility = visibility => {
    gtmEvent({
      event: 'formSubmit',
      formCategory: 'booking-type',
      formAction: `set-booking-type-${visibility}`,
    })
  }

  if (isEditFlow) {
    return (
      <Box className={editClasses.fieldGroup}>
        <Typography
          className={editClasses.sectionHeading}
          style={{ marginBottom: 12 }}
        >
          Visibility
        </Typography>
        <RadioGroup
          className={classes.optionsColumn}
          value={status}
          onChange={handleStatus}
        >
          {VISIBILITY_OPTIONS.map(option => (
            <FormControlLabel
              key={option.value}
              value={option.value}
              className={classes.optionLabel}
              control={<Radio className={classes.radio} color="primary" />}
              onClick={() =>
                setVisibility(option.value === 'ACTIVE' ? 'active' : 'inactive')
              }
              label={
                <Box>
                  <Typography className={classes.optionTitle}>
                    {option.title}
                  </Typography>
                  <Typography className={classes.optionDescription}>
                    {option.description}
                  </Typography>
                </Box>
              }
            />
          ))}
        </RadioGroup>
      </Box>
    )
  }

  return (
    <Box mt={3} mb={4}>
      <Typography variant="subtitle1" gutterBottom>
        Visibility
      </Typography>
      <FormControl>
        <RadioGroup
          aria-labelledby="Booking Type Status"
          defaultValue={status}
          onChange={handleStatus}
        >
          <FormControlLabel
            value="ACTIVE"
            control={<Radio color="primary" />}
            label="Public"
            onClick={() => {
              setVisibility('active')
            }}
          />
          <Typography
            variant="body2"
            gutterBottom
            style={{ marginLeft: '32px' }}
          >
            The booking type will be visible and bookable by you and your
            students.
          </Typography>
          <FormControlLabel
            value="INACTIVE"
            control={<Radio color="primary" />}
            label="Private"
            onClick={() => {
              setVisibility('inactive')
            }}
          />
          <Typography
            variant="body2"
            gutterBottom
            style={{ marginLeft: '32px' }}
          >
            The booking type will only be visible and bookable by you.
          </Typography>
        </RadioGroup>
      </FormControl>
    </Box>
  )
}

export default BookingTypeVisibility
